import { resolve } from "path"

export function parseQuery(query: string) {
    const obj: Record<string, any> = {}
    query.split('&').forEach((item) => {
        const array = item.split('=')
        obj[array[0]] = decodeURIComponent(array[1])
    })
    return obj
}

export function base64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/")

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray.buffer
}

/**
 * 返回图片的像素信息
 * @param 图片Image对象 image
 * @param 图片宽度 width
 * @param 图片高度 height
 * @returns Promise<[[r, g, b, a], [r, g, b, a], ...]>
 */
export function getImagePixelInfo(image, width, height) {
    var canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d") // 设置在画布上绘图的环境
    canvas.id = "CursorLayer"
    canvas.width = width
    canvas.height = height
    canvas.style.display = "none"
    document.body.appendChild(canvas)
    //获取画布宽高
    ctx?.drawImage(image, 0, 0, width, height) // 将图片绘制到画布上
    const imgData = ctx?.getImageData(0, 0, width, height) // 获取画布上的图像像素
    ctx?.clearRect(0, 0, width, height)
    return imgData?.data // 获取到的数据为一维数组,包含图像的RGBA四个通道数据
}

/**
 * blob->base64
 * @param {*} blob blob类型数据
 * @param {*} callback 成功回调
 */
export function blobToBase64(blob) {
    const fileReader = new FileReader()
    const promise = new Promise((resolve) => {
        fileReader.onload = (e) => {
            // callback(e.target.result)
            resolve(e.target?.result)
        }
        fileReader.readAsDataURL(blob)
    })

    return promise
}

export function fileToBase64(file): Promise<{
    status: boolean,
    data: FileReader['result']
}> {
    return new Promise((resolve, reject) => {
        // 创建FileReader对象（不兼容IE）
        let reader = new FileReader();
        // 将file转为base64 （异步操作）
        reader.readAsDataURL(file);
        // 转换成功
        reader.onload = () => {
            const response = {
                status: true,
                data: reader.result
            }
            resolve(response);
        };
        // 转换失败
        reader.onerror = function () {
            const response = {
                status: false,
                data: reader.error
            }
            reject(response);
        };
    })
}

export function formatTime(value = 0) {
    //  秒
    let second = value
    //  分
    let minute = 0
    //  如果秒数大于60，将秒数转换成整数
    if (second > 60) {
        //  获取分钟，除以60取整数，得到整数分钟
        minute = parseInt(second / 60 as any)
        //  获取秒数，秒数取佘，得到整数秒数
        second = parseInt(second % 60 as any)
    }
    return `${minute < 10 ? "0" + minute : minute}:${second < 10 ? "0" + second : second
        }`
}

const getUint8Arr = dataurl => {
    // 截取base64的数据内容
    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
        n = bstr.length,
        // 创建一个Uint8Array类型的数组以存放二进制数据
        u8arr = new Uint8Array(n)
    // 将二进制数据存入Uint8Array类型的数组中
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return { u8arr, mime }
}

export const dataURLtoFile = (dataurl, filename) => {//将base64转换为文件
    let uint8 = getUint8Arr(dataurl)
    return new File([uint8.u8arr], filename, { type: uint8.mime })
}

export const getBase64 = (file): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
    });

/**
 * 判断当前是否为Android
 * */
export function isAndroid() {
    if (/(Android)/i.test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}